module.exports = __webpack_public_path__ + "img/widget_notes.9cbe9d8.svg";